<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <form @submit.prevent="submit">
          <v-card
            class="mx-auto"
            max-width="650"
          >
            <v-card-title class="bg-primary d-flex align-center">
              <div class="banner-side d-flex align-center">
                <v-btn
                  color="white"
                  icon
                  to="/home"
                >
                  <v-icon size="large">
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </div>
              <span
                class="text-h5 white-text text-center"
                style="word-break: break-word"
              >
                Login - BCWhales Database Portal
              </span>
              <div class="banner-side" />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-alert
                v-if="message.text"
                type="error"
              >
                {{ message.text }}
              </v-alert>
              <v-text-field
                v-model="email"
                label="Email"
                prepend-icon="mdi-account"
              />
              <v-text-field
                v-model="password"
                label="Password"
                prepend-icon="mdi-lock"
                type="password"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn
                variant="text"
                :to="forgotPasswordPath"
              >
                Forgot Password?
              </v-btn>
              <v-spacer />
              <v-btn
                class="ml-2"
                color="primary"
                type="submit"
                :disabled="loading"
              >
                <span v-show="!loading">Login</span>
                <pulse-loader :loading="loading" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
// import HumpbackLogo from "@/components/svgs/HumpbackLogo";

export default {
  components: {
    PulseLoader,
    // HumpbackLogo,
  },

  data() {
    return {
      email: "",
      password: "",
      forgotPasswordPath: "/forgotPassword",
    };
  },
  computed: {
    ...mapGetters({
      loading: "auth/loading",
      isTokenSet: "auth/isTokenSet",
      message: "auth/message",
      role: "auth/role",
    }),
  },
  created() {
    this.reset();
    if (this.isTokenSet) {
      if (this.role === "admin") {
        this.$router.push({ name: "sightings" });
      }
      this.$router.push({ name: "sightings" });
    }
  },
  methods: {
    ...mapActions({
      reset: "auth/reset",
      login: "auth/login",
    }),
    async submit() {
      await this.login({
        email: this.email,
        password: this.password,
      });
      this.password = null;
    },
  },
};
</script>

<style scoped>
.banner-side {
  flex: 1 1 0;
}
</style>
